// Import main language files
import en from './en/en-US.json'
import es from './es/es-ES.json'
import it from './it/it-IT.json'
import pl from './pl/pl-PL.json'

// Import Polish section files (new structure based on pl-PL.json)
import pl_404 from './pl/404.json'
import pl_aboutUs from './pl/aboutUs.json'
import pl_accountSettings from './pl/accountSettings.json'
import pl_categories from './pl/categories.json'
import pl_certificate from './pl/certificate.json'
import pl_contact from './pl/contact.json'
import pl_paymentStatus from './pl/paymentStatus.json'
import pl_forgotPassword from './pl/forgotPassword.json'
import pl_resetPassword from './pl/resetPassword.json'
import pl_cookieBanner from './pl/cookieBanner.json'
import pl_signIn from './pl/signIn.json'
import pl_signUp from './pl/signUp.json'
import pl_hero from './pl/hero.json'
import pl_faq from './pl/faq.json'
import pl_footer from './pl/footer.json'
import pl_course from './pl/course.json'
import pl_courses from './pl/courses.json'
import pl_dashboard from './pl/dashboard.json'
import pl_sectionInfo from './pl/sectionInfo.json'
import pl_settings from './pl/settings.json'
import pl_player from './pl/player.json'
import pl_payments from './pl/payments.json'

// Import English section files (both new and existing)
import en_404 from './en/404.json'
import en_aboutUs from './en/aboutUs.json'
import en_accountSettings from './en/accountSettings.json'
import en_categories from './en/categories.json'
import en_certificate from './en/certificate.json'
import en_contact from './en/contact.json'
import en_paymentStatus from './en/paymentStatus.json'
import en_forgotPassword from './en/forgotPassword.json'
import en_resetPassword from './en/resetPassword.json'
import en_cookieBanner from './en/cookieBanner.json'
import en_signIn from './en/signIn.json'
import en_signUp from './en/signUp.json'
import en_hero from './en/hero.json'
import en_faq from './en/faq.json'
import en_footer from './en/footer.json'
import en_course from './en/course.json'
import en_courses from './en/courses.json'
import en_dashboard from './en/dashboard.json'
import en_sectionInfo from './en/sectionInfo.json'
import en_settings from './en/settings.json'
import en_player from './en/player.json'
import en_payments from './en/payments.json'

// Import Spanish section files (both new and existing)
import es_404 from './es/404.json'
import es_aboutUs from './es/aboutUs.json'
import es_accountSettings from './es/accountSettings.json'
import es_categories from './es/categories.json'
import es_certificate from './es/certificate.json'
import es_contact from './es/contact.json'
import es_paymentStatus from './es/paymentStatus.json'
import es_forgotPassword from './es/forgotPassword.json'
import es_resetPassword from './es/resetPassword.json'
import es_cookieBanner from './es/cookieBanner.json'
import es_signIn from './es/signIn.json'
import es_signUp from './es/signUp.json'
import es_hero from './es/hero.json'
import es_faq from './es/faq.json'
import es_footer from './es/footer.json'
import es_course from './es/course.json'
import es_courses from './es/courses.json'
import es_dashboard from './es/dashboard.json'
import es_sectionInfo from './es/sectionInfo.json'
import es_settings from './es/settings.json'
import es_player from './es/player.json'
import es_payments from './es/payments.json'

// Import Italian section files (both new and existing)
import it_404 from './it/404.json'
import it_aboutUs from './it/aboutUs.json'
import it_accountSettings from './it/accountSettings.json'
import it_categories from './it/categories.json'
import it_certificate from './it/certificate.json'
import it_contact from './it/contact.json'
import it_paymentStatus from './it/paymentStatus.json'
import it_forgotPassword from './it/forgotPassword.json'
import it_resetPassword from './it/resetPassword.json'
import it_cookieBanner from './it/cookieBanner.json'
import it_signIn from './it/signIn.json'
import it_signUp from './it/signUp.json'
import it_hero from './it/hero.json'
import it_faq from './it/faq.json'
import it_footer from './it/footer.json'
import it_course from './it/course.json'
import it_courses from './it/courses.json'
import it_dashboard from './it/dashboard.json'
import it_sectionInfo from './it/sectionInfo.json'
import it_settings from './it/settings.json'
import it_player from './it/player.json'
import it_payments from './it/payments.json'

const messages = {
  en: {
    global: en,
    '404': en_404,
    aboutUs: en_aboutUs,
    accountSettings: en_accountSettings,
    categories: en_categories,
    certificate: en_certificate,
    contact: en_contact,
    paymentStatus: en_paymentStatus,
    forgotPassword: en_forgotPassword,
    resetPassword: en_resetPassword,
    cookieBanner: en_cookieBanner,
    signIn: en_signIn,
    signUp: en_signUp,
    hero: en_hero,
    faq: en_faq,
    footer: en_footer,
    course: en_course,
    courses: en_courses,
    dashboard: en_dashboard,
    sectionInfo: en_sectionInfo,
    settings: en_settings,
    player: en_player,
    payments: en_payments
  },
  es: {
    global: es,
    '404': es_404,
    aboutUs: es_aboutUs,
    accountSettings: es_accountSettings,
    categories: es_categories,
    certificate: es_certificate,
    contact: es_contact,
    paymentStatus: es_paymentStatus,
    forgotPassword: es_forgotPassword,
    resetPassword: es_resetPassword,
    cookieBanner: es_cookieBanner,
    signIn: es_signIn,
    signUp: es_signUp,
    hero: es_hero,
    faq: es_faq,
    footer: es_footer,
    course: es_course,
    courses: es_courses,
    dashboard: es_dashboard,
    sectionInfo: es_sectionInfo,
    settings: es_settings,
    player: es_player,
    payments: es_payments
  },
  it: {
    global: it,
    '404': it_404,
    aboutUs: it_aboutUs,
    accountSettings: it_accountSettings,
    categories: it_categories,
    certificate: it_certificate,
    contact: it_contact,
    paymentStatus: it_paymentStatus,
    forgotPassword: it_forgotPassword,
    resetPassword: it_resetPassword,
    cookieBanner: it_cookieBanner,
    signIn: it_signIn,
    signUp: it_signUp,
    hero: it_hero,
    faq: it_faq,
    footer: it_footer,
    course: it_course,
    courses: it_courses,
    dashboard: it_dashboard,
    sectionInfo: it_sectionInfo,
    settings: it_settings,
    player: it_player,
    payments: it_payments
  },
  pl: {
    global: pl,
    '404': pl_404,
    aboutUs: pl_aboutUs,
    accountSettings: pl_accountSettings,
    categories: pl_categories,
    certificate: pl_certificate,
    contact: pl_contact,
    paymentStatus: pl_paymentStatus,
    forgotPassword: pl_forgotPassword,
    resetPassword: pl_resetPassword,
    cookieBanner: pl_cookieBanner,
    signIn: pl_signIn,
    signUp: pl_signUp,
    hero: pl_hero,
    faq: pl_faq,
    footer: pl_footer,
    course: pl_course,
    courses: pl_courses,
    dashboard: pl_dashboard,
    sectionInfo: pl_sectionInfo,
    settings: pl_settings,
    player: pl_player,
    payments: pl_payments
  },
};

export default messages;